import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForecastPageComponent } from './pages/forecast-page/forecast-page.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { UserRole } from '@reenstudio/app/core/enum/user-role';

const routes: Routes = [
  {
    path: '',
    component: ForecastPageComponent,
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: [
          UserRole.ADMIN,
          UserRole.CER,
          UserRole.INTRAPRESA,
          UserRole.SITE,
        ],
      },
      title: 'Previsionale',
      urls: [
        { title: 'Previsionale', url: '/predictive' },
        { title: 'Analisi previsionali' },
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ForecastRoutingModule {}
